export interface SuggestedAction {
  type: string;
  title: string;
  action_url: string;
  points: number;
  highlight: boolean;
}

export interface InsufficientPointsErrorData {
  error: string;
  code: string;
  message: string;
  current_balance: number;
  required: number;
  shortage: number;
  suggested_actions: SuggestedAction[];
}

export class ApiError extends Error {
  status: number;
  data: any;

  constructor(message: string, status: number, data?: any) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

export const ErrorCodes = {
  INSUFFICIENT_POINTS: "INSUFFICIENT_POINTS",
};
